export default __webpack_public_path__ + "static/media/priorityicon.f28d840a.svg";